import { createSlice } from '@reduxjs/toolkit'
import { fetchAllOrders, fetchCurrentOrderDetails, addOrderCourier, updateOrderCourier, updateOrderDetails } from '../actions/orderActions'

const OrderReducers = createSlice({
    name: 'OrderReducers',
    initialState: {
        loader: false,
        errors: null,
        order: null,
        orders: [],
        currentOrder: null,
        courier: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            /**
             * ALL ORDERS
             */
            .addCase(fetchAllOrders.pending, (state) => {
                state.loader = true;
                state.errors = null; 
            })
            .addCase(fetchAllOrders.fulfilled, (state, action) => {
                state.loader = false;
                state.orders = action.payload.data;
            })
            .addCase(fetchAllOrders.rejected, (state, action) => {
                state.loader = false;
                state.errors = action.payload; 
            })

            /**
             * FETCH CURRENT ORDER DETAILS
             */
            .addCase(fetchCurrentOrderDetails.pending, (state) => {
                state.loader = true;
                state.errors = null; 
            })
            .addCase(fetchCurrentOrderDetails.fulfilled, (state, action) => {
                state.loader = false;
                state.currentOrder = action.payload;
            })
            .addCase(fetchCurrentOrderDetails.rejected, (state, action) => {
                state.loader = false;
                state.errors = action.payload; 
            })

            /**
             * Add order courier
             */
            .addCase(addOrderCourier.pending, (state) => {
                state.loader = true;
                state.errors = null; 
            })
            .addCase(addOrderCourier.fulfilled, (state, action) => {
                state.loader = false;
                state.courier = action.payload;
            })
            .addCase(addOrderCourier.rejected, (state, action) => {
                state.loader = false;
                state.errors = action.payload; 
            })

            /**
             * Update order courier
             */
            .addCase(updateOrderCourier.pending, (state) => {
                state.loader = true;
                state.errors = null; 
            })
            .addCase(updateOrderCourier.fulfilled, (state, action) => {
                state.loader = false;
                state.courier = action.payload;
            })
            .addCase(updateOrderCourier.rejected, (state, action) => {
                state.loader = false;
                state.errors = action.payload; 
            })

            /**
             * Update order details
             */
            .addCase(updateOrderDetails.pending, (state) => {
                state.loader = true;
                state.errors = null; 
            })
            .addCase(updateOrderDetails.fulfilled, (state, action) => {
                state.loader = false;
                state.courier = action.payload;
            })
            .addCase(updateOrderDetails.rejected, (state, action) => {
                state.loader = false;
                state.errors = action.payload; 
            })
    }
})

export default OrderReducers.reducer